import { clearAllLoaders } from '@/redux/slices/common';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
const Terms = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearAllLoaders());
  }, []);
  return <div className="terms-conditions" data-sentry-component="Terms" data-sentry-source-file="terms.jsx">
            <div className="container pt-2 pb-6">
                <div className="terms-conditions-wrapper">
                    <div className="terms-conditions-txt">
                        <h4>Terms and Conditions:</h4>
                        <ol>
                            <li>
                                Chicking online delivery system is specially designed for customers who place orders
                                through Chicking Mobile Applications or through the online system at Chicking
                                restaurants located anywhere in UAE where the Chicking Order to be delivered.
                            </li>
                            <li>
                                It shall be the responsibility of the customer to ensure that delivery instructions are
                                clear and concise.
                            </li>
                            <li>The acceptance of order shall be at the entire discretion of Chicking ;</li>
                            <ol type="I" className="termsListRomanStyle">
                                <li>
                                    The delivery address being mapped to the nearest restaurant that delivers in
                                    customer area.
                                </li>
                                <li>Availability of Chicking products.</li>
                                <li>
                                    In case the delivery locality is not listed in the restaurant map, delivery orders
                                    cannot be placed.
                                </li>
                            </ol>
                            <li>
                                Chicking reserves the right, in its sole discretion, without limitations, conditions
                                and/or qualifications, and without need of prior notification, to limit, change, modify
                                or cancel any order, and/or to refuse any service to any customer for any reason
                                attributable to the unavailability of the items ordered, or other circumstances and
                                conditions beyond the control of Chicking which would render impossible or delay the
                                fulfillment of its obligations.
                            </li>
                            <li>
                                Chicking reserves the right to refuse or to accept or to cancel any order from any
                                customer beyond the delivery area or otherwise.
                            </li>
                            <li>Delivery orders are subject to:</li>

                            <ol type="I" className="termsListRomanStyle">
                                <li>
                                    Once the order has been placed it cannot be changed or cancelled by the customers
                                    for any reason.
                                </li>
                                <li>The prices of the Chicking products are inclusive of Value Added Tax (VAT).</li>
                                <li>
                                    Chicking shall use its best efforts to meet the scheduled delivery time conveyed by
                                    the Chicking however; it does not guarantee these delivery timelines in every case.
                                    Chicking shall not have any liability to customer if the customer&#39;s order fails
                                    to meet in whole or in part such scheduled delivery time.
                                </li>
                                <li>
                                    It is customer’s responsibility to ensure that customer himself/herself or an
                                    appropriate person is available at the delivery address and he/she must pay in full
                                    for the order placed through Chicking. If customer or appropriate person fails to be
                                    present, Chicking is entitled to charge the customer in full amount of order and the
                                    cost of delivery.
                                </li>
                                <li>
                                    In the Cash on Delivery orders, the payment shall be made in liquid cash and
                                    vouchers or coupons are not accepted.
                                </li>
                            </ol>

                            <li>
                                Upon delivery, customer shall pay in cash all fees and charges (including delivery
                                charges mentioned above) incurred in connection with the order, including any and all
                                applicable taxes, at the rate in effect when the charges were incurred. Alternately,
                                while placing the order on the Chicking Mobile App, customers may choose the online
                                payment option, upon which they shall be redirected to an external payment gateway, on
                                which they are required to follow the payment gateway’s separate instructions for
                                effecting online payment. The payment gateway is not under Chicking’s control, and
                                Chicking is not responsible for and shall not be liable to any extent or in any manner
                                for any payment-related or internet-related issues faced by customers in relation to
                                online payments, and customers shall indemnify and keep fully and effectively
                                indemnified Chicking and its affiliates in this regard.
                            </li>
                            <li>
                                Chicking reserves the right to reject the Delivery order and to cancel the same once it
                                is accepted:
                            </li>
                            <ol type="I" className="termsListRomanStyle">
                                <li>
                                    In case Chicking is unable to contact the customer due to any reason whatsoever on
                                    the mobile or landline number of the customer as provided by the customer at the
                                    time of placing the order;
                                </li>
                                <li>In case of non-receipt of payment in full or in part in any previous order.</li>
                                <li>
                                    In case of abuse to any employee/ representative /riders of Chicking in any previous
                                    incident.
                                </li>
                                <li>If customer has provided wrong, inaccurate, incomplete or incorrect address.</li>
                                <li>
                                    In view of difficult operating conditions for Chicking like heavy traffic or
                                    accidents or bad weather etc.
                                </li>
                                <li>
                                    In any other event at the sole discretion of Chicking, without the need to assign
                                    any reason or explanation.
                                </li>
                            </ol>
                            <li>Menu and prices are subject to change without notice.</li>
                            <li>
                                Chicking may change the terms of, or add new terms to, these Terms and Conditions at any
                                time, with or without cause, and without giving notice.
                            </li>
                            <li>
                                It is clarified that, by placing an order/s through Chicking Mobile App, a customer
                                unconditionally and fully accepts all above terms and conditions.
                            </li>
                            <li>
                                By registering on Chicking Mobile App, you allow Chicking to contact you for offers and
                                updates relating to your account.
                            </li>
                            <li>
                                To the extent permitted by law, Chicking provides our Service and content on an
                                &quot;as-is&quot; and &quot;as available&quot; basis and we make no representation or
                                warranty of any kind, express or implied, regarding the content or availability of our
                                Service, or that it will be timely or error-free or that defects will be corrected.
                                Subject as provided below, Chicking don’t have any liability to you for any direct,
                                indirect, special or consequential losses or damages arising in contract, tort
                                (including negligence) or otherwise arising from your use of or your inability to use
                                our Service. In the event that Chicking is found to be liable to you our total aggregate
                                liability is limited to the purchase price of the Meals you have paid for in your order.
                            </li>
                            <li>
                                Chicking shall not be responsible for any delay or non-performance of its obligations
                                arising from any cause beyond its control including, without limitation, any of the
                                following: act of God, governmental act, war, fire, flood, explosion or civil commotion.
                            </li>
                            <li>
                                In case of any dispute with respect to Chicking, the decision of Chicking’s Management
                                shall be final and binding on all concerned. Disputes, if any, are subject to the
                                jurisdiction of the competent Court/s at Dubai, UAE only.
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>;
};
export default Terms;